import { TooltipBase } from "@frontend/common/src/components";

import * as S from "./ListMultipleShell.style";
import { EMPTY_SHELL_VALUE } from "../../../../constants/publicationListTable.constants";

type Props = {
  name: string[] | null;
};

const ListMultipleShell = ({ name }: Props) => {
  if (!name || name.length === 0 || name.every((item) => !item)) {
    return <S.ListShell>{EMPTY_SHELL_VALUE}</S.ListShell>;
  }

  const visibleCompanies = name ? name.slice(0, 2) : [];
  const remainingCount = name && name.length > 2 ? name.length - 2 : 0;

  const tooltipVisibleCompanies = name ? name.slice(0, 12) : [];
  const tooltipRemainingCount = name && name.length > 12 ? name.length - 12 : 0;

  return (
    <S.ListShell>
      {visibleCompanies.map((item) => (
        <S.ListItem key={item}>
          <S.ListItemText>{item}</S.ListItemText>
        </S.ListItem>
      ))}

      {remainingCount > 0 && (
        <>
          <S.ListNumber>+{remainingCount}</S.ListNumber>
          <S.TooltipWrapper className="tooltip-wrapper">
            <TooltipBase className="tooltip">
              {tooltipVisibleCompanies.map((item) => (
                <S.ListItem key={item}>
                  <S.ListItemText>{item}</S.ListItemText>
                </S.ListItem>
              ))}
              {tooltipRemainingCount > 0 && (
                <S.ListNumber>+{tooltipRemainingCount}</S.ListNumber>
              )}
            </TooltipBase>
          </S.TooltipWrapper>
        </>
      )}
    </S.ListShell>
  );
};

export default ListMultipleShell;
